module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/app/register/src/locales",
  "moduleName": "H5-global-fe-Growth-driver-page",
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-Growth-driver-page/app/register/src/locales/all.js",
  "prefix": "register---",
  "noParse": false
}